import { BaseService } from "./BaseService";
import { BookingCheckin } from "@/types/booking-checkin";

class BookingCheckinService extends BaseService {
  private basePath = "/booking-checkins";

  constructor() {
    super();
  }

  async getCheckinByBookingId(
    bookingId: string,
  ): Promise<BookingCheckin | null> {
    const checkin = await this.get<BookingCheckin | null | undefined>(
      `${this.basePath}/by-booking/${bookingId}`,
    );

    return checkin ?? null;
  }
}

export const bookingCheckinService = new BookingCheckinService();
